<template>
  <div id="app">
    <AgreementPage />
  </div>
</template>

<script>
import AgreementPage from './components/AgreementPage.vue'

export default {
  name: 'App',
  components: {
    AgreementPage
  }
}
</script>

<style>
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f7f7f7;
}

#app {
  width: 100%;
  min-height: 100vh;
}
</style>
